import { Button, CircularProgress } from "@material-ui/core";
import { useCallback } from "react";
import { useApartment } from "../../../graphql/hooks";
import { useLoggedUserInfo } from "../../../hooks";

export type GenerateApartmentsSurveysReportProps = {};
export function GenerateApartmentsSurveysReport(
  props: GenerateApartmentsSurveysReportProps
) {
  const { userBuilding } = useLoggedUserInfo();
  const { createApartmentSurveysReport, createApartmentSurveysReportLoading } =
    useApartment({
      onApartmentsReportCreated(attachment) {
        window.open(attachment.url);
      },
    });

  const triggerCreateApartmentSurveysReport = useCallback(() => {
    createApartmentSurveysReport(userBuilding?.id);
  }, [createApartmentSurveysReport, userBuilding]);

  return (
    <Button
      disabled={createApartmentSurveysReportLoading}
      onClick={triggerCreateApartmentSurveysReport}
    >
      {!createApartmentSurveysReportLoading && "Scarica report questionari"}
      {createApartmentSurveysReportLoading && <CircularProgress />}
    </Button>
  );
}
